import { CONTACT_CCR_MODULE_KEY, resolveEnabledAdminModules } from "./adminModules";
import { hasSuperAdminAccess } from "./roleAccess";

export const canShowContactCcr = (user, optionKeys) =>
	hasSuperAdminAccess(user) ||
	new Set(resolveEnabledAdminModules(optionKeys)).has(CONTACT_CCR_MODULE_KEY);
